import { render, staticRenderFns } from "./AbkRecommendedProfiles.vue?vue&type=template&id=91933cb2&scoped=true&"
import script from "./AbkRecommendedProfiles.vue?vue&type=script&lang=js&"
export * from "./AbkRecommendedProfiles.vue?vue&type=script&lang=js&"
import style0 from "./AbkRecommendedProfiles.vue?vue&type=style&index=0&id=91933cb2&scoped=true&lang=scss&"
import style1 from "./AbkRecommendedProfiles.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91933cb2",
  null
  
)

export default component.exports